module.exports = __webpack_public_path__ + "static/img/wealth_level_83.4ad6b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_83.png
// module id = a20J
// module chunks = 0